import React, { useState } from "react";
import CommonFormLabel from "../../components/formLabel";
import Input from "../../components/input";
import { useNavigate, useLocation } from "react-router-dom";
import ValidationFeedback from "../../components/validationFeedback";
import CommonButton from "../../components/commonButton";
// import CommonEditor from "../../components/commonEditor";
import { useDispatch } from "react-redux";
import { Toast, Form, Row, Col, Card } from "react-bootstrap";
import { Formik } from "formik";
import { galleryCategorySchema } from "../../schema/validationSchemas";
import { addGalleryCategory } from "./galleryCategorySlice";

export default function Add() {
  const navigate = useNavigate();
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarVariant, setSnackbarVariant] = useState("success");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [attributes, setAttributes] = useState([]);
  const dispatch = useDispatch();

  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const currentPage = params.get("page") || 1;
  const pathSegments = location.pathname.split("/").filter(Boolean);
  const selected_organization_id = pathSegments.length > 1 && pathSegments[0] === "organization" 
    ? pathSegments[1] 
    : null;


  const initialEventState = {
    organization_id: selected_organization_id,
    // parent_category_id: "",
    name: "",
  };

  const resetAttributes = () => {
    setAttributes([]);
  };

  const handleModalClose = () => {
    navigate(`/organization/${selected_organization_id}/gallery-categories?page=${currentPage}`);
  };

  const handleSubmit = async (values, { setSubmitting, setErrors }) => {
    setIsSubmitting(true);

    const dataToSubmit = {
      ...values,
      attribute_groups: attributes.map((attribute) => ({
        name: attribute.name,
        values: attribute.values.filter((value) => value !== ""),
      })),
    };

    await dispatch(addGalleryCategory(dataToSubmit))
      .then((res) => {
        if (res.payload && res.payload.success) {
          localStorage.setItem("gallery_category_notify_message", res.payload.message);
          setSnackbarMessage(res.payload.message);
          setSnackbarVariant("success");
          setShowSnackbar(true);
          setSubmitting(false);
          setIsSubmitting(false);
          resetAttributes();
          navigate(`/organization/${selected_organization_id}/gallery-categories`);
        } else {
          // setSnackbarMessage("Failed to add category!");
          setErrors(res.payload.data);
          setSnackbarMessage(res.payload.message || "Failed to add category!");
          setSnackbarVariant("danger");
          setShowSnackbar(true);
          setSubmitting(false);
          setIsSubmitting(false);
        }
      })
      .catch((error) => {
        console.error("Error:", error);
        setSnackbarMessage("Failed to add category!");
        setSnackbarVariant("danger");
        setShowSnackbar(true);
        setSubmitting(false);
        setIsSubmitting(false);
      });
  };

  return (
    <>
      <Toast
        onClose={() => setShowSnackbar(false)}
        show={showSnackbar}
        delay={3000}
        autohide
        bg={snackbarVariant}
        style={{ position: "fixed", top: 20, right: 20, zIndex: 1000 }}
      >
        <Toast.Body style={{ color: "white" }}>{snackbarMessage}</Toast.Body>
      </Toast>

      <Formik
        initialValues={initialEventState}
        validationSchema={galleryCategorySchema}
        onSubmit={handleSubmit}
      >
        {({
          errors,
          touched,
          handleChange,
          handleSubmit,
          values,
          setFieldValue,
        }) => (
          <Form
            onSubmit={handleSubmit}
            encType="multipart/form-data"
            className="bg-white p-4 rounded-2 shadow-sm"
          >
            {/* <h3 className="mb-4 text-center">Add New Category</h3> */}
            <Card className="bg-white p-4 rounded-2 shadow-sm mb-4">
            <h4 className="mb-4 d-flex justify-content-center">Basic</h4>
              <Row>
                <Col md={12} className="">
                  <CommonFormLabel
                    htmlFor="name"
                    title="Category Name"
                  />
                  <Input
                    id="name"
                    name="name"
                    type="text"
                    placeholder="Enter Category Name"
                    onChange={(e) => {
                      const categoryName = e.target.value;
                      setFieldValue("name", categoryName);
                    }}
                    className={`shadow-none ${
                      errors?.name && touched.name
                        ? "error"
                        : "correct"
                    }`}
                  />
                  {touched.name && errors?.name && (
                    <ValidationFeedback title={errors?.name} />
                  )}
                </Col>
              </Row>

           
            </Card>

            <div className="d-flex align-items-center justify-content-end gap-3 common-popup-btn mt-5">
              <CommonButton
                title={isSubmitting ? "Adding..." : "Add"}
                type="submit"
                disabled={isSubmitting}
                className="btn-primary primary-shadow"
              />
              <CommonButton
                title="Cancel"
                onClick={handleModalClose}
                className="btn-muted"
              />
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
}
